import React from 'react';
import logo from '../assets/logo.png';
import './Logo.css';

const VARIANT_CLASS = {
  auth: 'logo--auth',
  sidebar: 'logo--sidebar',
  topbar: 'logo--topbar',
  mobile: 'logo--mobile',
  form: 'logo--form',
  banner: 'logo--banner',
  modal: 'logo--modal',
};

const Logo = ({ variant = 'auth', className, style, width, height, ...props }) => {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.auth;
  const classes = ['app-logo', variantClass, className].filter(Boolean).join(' ');

  const legacySizeStyle =
    width || height
      ? {
          ...(width ? { width, maxWidth: width } : {}),
          ...(height ? { maxHeight: height, height: 'auto' } : {}),
        }
      : null;

  return (
    <img
      src={logo}
      alt="GTA5RP"
      className={classes}
      style={{ ...legacySizeStyle, ...style }}
      draggable={false}
      decoding="async"
      {...props}
    />
  );
};

export default Logo;
